import React, { useState, useEffect } from 'react';
import { Edit, Save } from 'lucide-react';
import { Button } from '../../components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';
import axios from 'axios';

const PackagesManager = () => {
  const [packages, setPackages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [editing, setEditing] = useState(null);
  const [formData, setFormData] = useState({});

  useEffect(() => {
    fetchPackages();
  }, []);

  const fetchPackages = async () => {
    try {
      const token = localStorage.getItem('admin_token');
      const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/admin/packages`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setPackages(response.data.packages);
    } catch (error) {
      console.error('Error:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleSave = async () => {
    try {
      const token = localStorage.getItem('admin_token');
      await axios.put(
        `${process.env.REACT_APP_BACKEND_URL}/api/admin/packages/${editing}`,
        formData,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setEditing(null);
      fetchPackages();
      alert('Forfait mis à jour !');
    } catch (error) {
      alert('Erreur');
    }
  };

  if (loading) return <div className="flex justify-center py-12"><div className="animate-spin rounded-full h-12 w-12 border-b-2 border-purple-600"></div></div>;

  return (
    <div className="space-y-6">
      <h1 className="text-3xl font-bold">Forfaits</h1>
      <p className="text-gray-600">Modifiez les 3 forfaits (Essentiel, Premium, Luxe)</p>
      <div className="grid md:grid-cols-3 gap-4">
        {packages.map((pkg) => (
          <Card key={pkg.id}>
            <CardHeader>
              <CardTitle>{pkg.name}</CardTitle>
            </CardHeader>
            {editing === pkg.id ? (
              <CardContent className="space-y-3">
                <div><Label>Nom (FR)</Label><Input value={formData.name || ''} onChange={(e) => setFormData({ ...formData, name: e.target.value })} /></div>
                <div><Label>Name (EN)</Label><Input value={formData.name_en || ''} onChange={(e) => setFormData({ ...formData, name_en: e.target.value })} /></div>
                <div><Label>Prix (numérique)</Label><Input value={formData.price || ''} onChange={(e) => setFormData({ ...formData, price: e.target.value })} /></div>
                <div><Label>Description (FR)</Label><Input value={formData.description || ''} onChange={(e) => setFormData({ ...formData, description: e.target.value })} /></div>
                <div><Label>Description (EN)</Label><Input value={formData.description_en || ''} onChange={(e) => setFormData({ ...formData, description_en: e.target.value })} /></div>
                <p className="text-xs text-gray-500">Features: Modifier dans code pour l'instant</p>
                <div className="flex gap-2 pt-2">
                  <Button onClick={handleSave} className="bg-green-600 w-full"><Save className="w-4 h-4 mr-2" />Sauvegarder</Button>
                  <Button onClick={() => setEditing(null)} variant="outline" className="w-full">Annuler</Button>
                </div>
              </CardContent>
            ) : (
              <CardContent>
                <div className="space-y-2">
                  <p className="text-3xl font-bold text-purple-600">{pkg.price}$</p>
                  <p className="text-sm text-gray-600">{pkg.description}</p>
                  <p className="text-xs text-gray-500">{pkg.features?.length || 0} caractéristiques</p>
                  <Button size="sm" onClick={() => { setEditing(pkg.id); setFormData(pkg); }} className="w-full mt-4">
                    <Edit className="w-4 h-4 mr-2" />Modifier
                  </Button>
                </div>
              </CardContent>
            )}
          </Card>
        ))}
      </div>
    </div>
  );
};

export default PackagesManager;
